import type { ViewManifest } from "./manifest"

const manifest: ViewManifest = {
  label: "Data",
  href: "/",
  target: "spaestiem-index",
  order: 0,
  async relevance(graphStore) {
    const size = await graphStore.size()
    return size > 0
      ? `${size.toLocaleString("en-US")} triple${size > 1 ? "s" : ""}`
      : "Data"
  },
}
export default manifest
